import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { AuthProvider } from "./contexts/AuthProvider";

// 👇 QUAN TRỌNG: import i18n TRƯỚC khi render
import "./i18n";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root not found");

createRoot(rootEl).render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>
);
